var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconScalpMoistureLGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#939393",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 16.254C22 19.427 19.314 22 16 22s-6-2.573-6-5.746a5.642 5.642 0 0 1 .713-2.747L16 4l5.287 9.507c.47.846.714 1.79.713 2.747zM9 9.446C9 10.856 7.88 12 6.5 12S4 10.857 4 9.446c0-.425.102-.845.297-1.22L6.5 4l2.203 4.225c.195.376.297.796.297 1.221z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.643 20.043c1.492.824 2.357 1.861 2.357 3.015C28 25.876 22.84 28 16 28S4 25.876 4 23.058c0-1.174.896-2.228 2.436-3.058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64 22.006c-.411.26-.64.545-.64.844C8 24.033 11.582 25 16 25s8-.967 8-2.15c0-.302-.231-.589-.65-.85M16 19c-1.676-.021-3.018-1.363-3-3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScalpMoistureLGray);
export default __webpack_public_path__ + "static/media/icon_scalp_moisture_l_gray.4397a558.svg";
export { ForwardRef as ReactComponent };